/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum FrequencyType {
  Weekly = "Weekly",
  DayBeforeDueDate = "DayBeforeDueDate",
  DayOfDueDate = "DayOfDueDate",
}

export const FrequencyTypeDisplay: Record<FrequencyType, string> = {
  [FrequencyType.Weekly]: "Weekly",
  [FrequencyType.DayBeforeDueDate]: "Day Before Due Date",
  [FrequencyType.DayOfDueDate]: "Day Of Due Date",
};
